module.exports = __webpack_public_path__ + "img/email_template.777a68ee.svg";